import { render, staticRenderFns } from "./PatientProfileEditor.vue?vue&type=template&id=707d4450&scoped=true&"
import script from "./PatientProfileEditor.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d4450",
  null
  
)

export default component.exports